export default __webpack_public_path__ + "static/media/illustration-mian-w@2x.464d923a.webp";